import api from "./axios";

const authHeaders = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const getProducts = (token) => api.get("/product", authHeaders(token));
export const getProduct = (id, token) => api.get(`/product/${id}`, authHeaders(token));
export const createProduct = (data, token) => api.post("/product/create", data, authHeaders(token));
export const updateProduct = (id, data, token) => api.put(`/product/${id}`, data, authHeaders(token));
export const toggleProduct = (id, token) => api.put(`/product/${id}/toggle`, {}, authHeaders(token));
export const deleteProducts = (ids, token) => api.post("/product/delete", { ids }, authHeaders(token));

